"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = exports.VERSION = exports.HttpStatusCode = exports.CanceledError = exports.CancelToken = exports.Cancel = exports.AxiosHeaders = exports.AxiosError = exports.Axios = void 0;
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _axios.default;
  }
});
exports.toFormData = exports.spread = exports.mergeConfig = exports.isCancel = exports.isAxiosError = exports.getAdapter = exports.formToJSON = void 0;
var _axios = _interopRequireDefault(require("./lib/axios.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var Axios = _axios.default.Axios,
  AxiosError = _axios.default.AxiosError,
  CanceledError = _axios.default.CanceledError,
  isCancel = _axios.default.isCancel,
  CancelToken = _axios.default.CancelToken,
  VERSION = _axios.default.VERSION,
  all = _axios.default.all,
  Cancel = _axios.default.Cancel,
  isAxiosError = _axios.default.isAxiosError,
  spread = _axios.default.spread,
  toFormData = _axios.default.toFormData,
  AxiosHeaders = _axios.default.AxiosHeaders,
  HttpStatusCode = _axios.default.HttpStatusCode,
  formToJSON = _axios.default.formToJSON,
  getAdapter = _axios.default.getAdapter,
  mergeConfig = _axios.default.mergeConfig;
exports.mergeConfig = mergeConfig;
exports.getAdapter = getAdapter;
exports.formToJSON = formToJSON;
exports.HttpStatusCode = HttpStatusCode;
exports.AxiosHeaders = AxiosHeaders;
exports.toFormData = toFormData;
exports.spread = spread;
exports.isAxiosError = isAxiosError;
exports.Cancel = Cancel;
exports.all = all;
exports.VERSION = VERSION;
exports.CancelToken = CancelToken;
exports.isCancel = isCancel;
exports.CanceledError = CanceledError;
exports.AxiosError = AxiosError;
exports.Axios = Axios;